import React, {useState, useEffect, useCallback} from "react";
import {Row, Col, FormGroup, Input, ModalFooter} from "reactstrap";
import Button from "../Button/Button";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {
  getPermissionList,
  getUsersList,
  getGroupModalData,
} from "../../redux/Selectors/group.selector";
import Select from "react-select";
import {
  sendEditGroupModalData,
  sendAddgroupModalData,
  updateAddgroupModalData,
} from "../../redux/Actions/group.action";
import {isEmpty} from "lodash";
import {toast} from "react-toastify";
import {useFetchGroups} from "../../views/Group/groupsTable/useGroupsTableData";

const GroupForm = ({onClose}) => {
  const dispatch = useDispatch();
  const {refetch} = useFetchGroups();
  const permission_list = useSelector(getPermissionList);
  const user_list = useSelector(getUsersList);
  const update_group_data = useSelector(getGroupModalData);
  const [submitted, setSubmitted] = useState(false);
  const {name = "", permissions = [], users = []} = update_group_data;
  const handleOnchangePermission = (val) => {
    let updateObj = {...update_group_data};
    updateObj = Object.assign({}, updateObj, {["permissions"]: val});
    dispatch(updateAddgroupModalData(updateObj));
  };
  const handleOnchangeUser = (val) => {
    let updateObj = {...update_group_data};
    // let result = val.map(({value}) => value);
    updateObj = Object.assign({}, updateObj, {["users"]: val});
    dispatch(updateAddgroupModalData(updateObj));
  };

  const onChangeHandler = (e) => {
    let updateObj = {...update_group_data};
    updateObj = Object.assign({}, updateObj, {[e.target.name]: e.target.value});
    dispatch(updateAddgroupModalData(updateObj));
  };
  // const {name = ""} = simPayload;
  const onFormSubmit = () => {
    setSubmitted(true);
    if (!isEmpty(name)) {
      const callback = () => {
        onClose();
        refetch();
      };
      if (update_group_data.id) {
        dispatch(sendEditGroupModalData(update_group_data, callback));
      } else {
        dispatch(sendAddgroupModalData(update_group_data, callback));
      }
    } else {
      toast.error("Please check required fields");
    }
  };
  const onFormCancel = useCallback(() => {
    dispatch(updateAddgroupModalData({}));
    onClose();
  }, [dispatch, onClose]);
  useEffect(() => {
    window.addEventListener("beforeunload", onFormCancel);
    return () => {
      window.removeEventListener("beforeunload", onFormCancel);
    };
  }, [onFormCancel]);

  return (
    <>
      <div>
        <div className="pl-lg-4">
          <Row>
            <Col lg="12">
              <FormGroup>
                <label className="form-control-label" htmlFor="name">
                  NAME <span className="text-red">*</span>
                </label>
                <Input
                  className="form-control-alternative"
                  // defaultValue="United States"
                  id="name"
                  placeholder="name"
                  type="text"
                  data-cy={"group_name"}
                  value={name}
                  invalid={isEmpty(name) && submitted}
                  name="name"
                  onChange={onChangeHandler}
                />
              </FormGroup>
            </Col>
            <Col lg="12">
              <label className="form-control-label" htmlFor="permissions">
                PERMISSIONS
              </label>
              <Select
                closeMenuOnSelect={false}
                options={permission_list}
                onChange={handleOnchangePermission}
                value={permissions}
                classNamePrefix={"select_permissions"}
                id={"select_permissions"}
                isMulti
              />
            </Col>
            <Col lg="12">
              <label className="form-control-label" htmlFor="user">
                USER
              </label>
              <Select
                closeMenuOnSelect={false}
                options={user_list}
                onChange={handleOnchangeUser}
                value={users}
                classNamePrefix={"select_users"}
                id={"select_users"}
                isMulti
              />
            </Col>
          </Row>
        </div>
      </div>
      <ModalFooter>
        <Button data-cy="submit-btn" onClick={onFormSubmit}>
          SUBMIT
        </Button>
        <Button onClick={onFormCancel} type={"info-small"} data-cy={"cancel-btn"}>
          CANCEL
        </Button>
      </ModalFooter>
    </>
  );
};

GroupForm.propTypes = {
  onFormSubmit: PropTypes.func.isRequired,
};

export default GroupForm;
